import { render } from 'preact'
import './main.css'
import { App } from './views/app.tsx'

render(<App />, document.getElementById('app')!)
